<div *ngIf="isLoading" class="loading">
  Verifying link...
</div>

<div *ngIf="!isLoading && isLinkValid" class="reset-card">
  <div class="header">
    <h2>🔒 Reset Password</h2>
    <p class="subtitle">Please enter and confirm your new password.</p>
  </div>

  <form autocomplete="off">
    <div class="form-group">
      <label>Enter Password</label>
      <div class="input-icon">
        <input
          [type]="showPassword ? 'text' : 'password'"
          [(ngModel)]="newPassword"
          name="newPassword"
        />
        <span (click)="togglePasswordVisibility()" class="toggle-icon">
          <i class="material-icons">
            {{ showPassword ? 'visibility_off' : 'visibility' }}
          </i>
        </span>
      </div>
    </div>

    <div class="form-group">
      <label>Retype Password</label>
      <input
        [type]="showPassword ? 'text' : 'password'"
        [(ngModel)]="retypePassword"
        name="retypePassword"
      />
    </div>

    <div *ngIf="passwordError" class="error-msg">
      {{ passwordError }}
    </div>

    <button type="button" (click)="resetPassword()">Reset Password</button>
  </form>
</div>

<div *ngIf="!isLoading && !isLinkValid" class="error-card">
  <h2>❌ Invalid or Expired Link</h2>
  <p>{{ serverError }}</p>
</div>

<!-- ✅ Success Modal -->
<div *ngIf="showSuccessModal" class="modal-backdrop">
  <div class="modal">
    <h3>Password Reset Successful ✅</h3>
    <p>Your password has been updated. Please log in with your new credentials.</p>
    <button (click)="closeModal()">Go to Login</button>
  </div>
</div>
